export default __webpack_public_path__ + "assets/images/2b596b4983c6a354186a36c332ce1f0b.png";